import { Warehouse as WarehouseDto } from "src/app/proxy/warehouses";
import { WarehouseType } from "../../../app/proxy/warehouses/enums";

export class Warehouse {
  id: number;
  name?: string;
  warehouseManagerId?: number;
  zoneId: number;
  regionId: number;
  type: WarehouseType;

  constructor(dto: WarehouseDto) {
    Object.assign(this, dto);
  }
}